import React from 'react';

import './index.scss';

//materila-ui
import { CircularProgress, Button, Dialog, DialogActions, DialogContent, DialogTitle, ListItem,
    createMuiTheme,
    MuiThemeProvider,
    Collapse,
    ListItemText,
    List
} from '@material-ui/core';

import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

//api
import {api} from '../../../functions/api';

//custom components
import CustomInput from '../../../components/basic/input'
import SelectSearch from '../../../components/basic/SelectSearch/SelectSearch'

//other libraries
import {toJS} from 'mobx';
import { inject, observer } from 'mobx-react';

const theme = createMuiTheme ({
    typography: {
        useNextVariants: true
    },
    overrides: {
        MuiDialogContent: {
            root: {
                overflow: "initial",
                overflowY: "initial"
            }
        },
        MuiDialogActions: {
            root: {
                overflow: "initial"
            }
        },
        MuiPaper: {
            root: {
                maxWidth: "400px !important"
            }
        }
    }
})

@inject('internal')
@inject('translate')
@observer
export default class AddEditPaymentType extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            openSnackbar: false,
            message: "",
            name: "",
            price: "",
            free_from: "",
            description: "",
            production: null,
            vat: "",
            allShops: [],
            selectedShops: [],
            is_gopay: false,
            is_homecredit: false,
            is_gpwebpay: false,
            gopay_id: null,
            gopay_client_id: null,
            gopay_client_secret: null,
            homecredit_client_id: null,
            homecredit_client_secret: null,
        }
    }

    componentDidMount() {
        let shopsTmp = toJS(this.props.internal.dataForTable.lists.shops)
        let shops = [];
        for(let i in shopsTmp) {
            let tmp = {
                label: shopsTmp[i].name,
                value: shopsTmp[i].id
            }
            shops.push(tmp);
        }
        this.setState({allShops: shops})

        if(toJS(this.props.internal.actionEdit.edit)) {
            
            this.loadPaymentType();
        }
        else {
            this.setState({production: false})
        }
        
    }

    handleChangeCheckbox = (event) => {
        this.setState({production: event.target.checked})
    }

    handleGPWebPayCheckbox = (event) => {
        this.setState({is_gpwebpay: event.target.checked})
    }

    loadPaymentType = async() => {
        this.setState({loading: true})
        let idPaymentType = toJS(this.props.internal.actionEdit.id)
        
        let load_payment_type = await api({
            method: 'get',
            url: `lists/payment-types/${idPaymentType}`,
            authorization: this.props.internal.user.access_token,
            
        });

        if(load_payment_type.success === true ) {
            this.props.internal.setDataForSimpeTable(load_payment_type.data.data)
            let shopsTmp = load_payment_type.data.data.available_for
            let shops = [];
            for(let i in shopsTmp) {
                let tmp = {
                    label: shopsTmp[i].name,
                    value: shopsTmp[i].id
                }
                shops.push(tmp);
            }
            this.setState({
                selectedShops: shops,
                name: load_payment_type.data.data.name,
                price: load_payment_type.data.data.price,
                free_from: load_payment_type.data.data.free_from,
                description: load_payment_type.data.data.description,
                production: load_payment_type.data.data.production,
                vat: load_payment_type.data.data.vat,
                is_gopay: load_payment_type.data.data.is_gopay,
                is_homecredit: load_payment_type.data.data.is_homecredit,
                is_gpwebpay: load_payment_type.data.data.is_gpwebpay,
                gopay_id: load_payment_type.data.data.gopay_id,
                gopay_client_id: load_payment_type.data.data.gopay_client_id,
                gopay_client_secret: load_payment_type.data.data.gopay_client_secret,
                homecredit_client_id: load_payment_type.data.data.homecredit_client_id,
                homecredit_client_secret: load_payment_type.data.data.homecredit_client_secret,
                loading: false,
            })
        }
        else{
            this.setState({loading: false})
        }
        
    }

    createNewPaymentType = async () => {
        let name = this.name.state.value;
        let price = Number(this.price.state.value);
        let free_from = Number(this.free_from.state.value);
        let description = this.description.state.value;
        let production = this.state.production;
        let vat = Number(this.vat.state.value)

        let params = {
            name: name,
            price: price,
            description: description,
            free_from: free_from,
            production: production,
            vat: vat,
        }

        let gopay_id;
        let gopay_client_id;
        let gopay_client_secret;

        let homecredit_client_id;
        let homecredit_client_secret;

        if(this.state.is_gopay) {
            gopay_id = this.gopay_id.state.value
            gopay_client_id = this.gopay_client_id.state.value
            gopay_client_secret = this.gopay_client_secret.state.value

            params.is_gopay = true
            params.gopay_id = gopay_id
            params.gopay_client_id = gopay_client_id
            params.gopay_client_secret = gopay_client_secret
        }
    
        params.is_gpwebpay = this.state.is_gpwebpay;
        
        if(this.state.is_homecredit) {
            homecredit_client_id = this.homecredit_client_id
            homecredit_client_secret = this.homecredit_client_secret

            params.is_homecredit = true
            params.homecredit_client_id = homecredit_client_id
            params.homecredit_client_secret = homecredit_client_secret
        }

        if(name !== "" ) {

        let idPaymentType = toJS(this.props.internal.actionEdit.id)
        let url = 'lists/payment-types'
        let method = 'post'
        if(idPaymentType) {
            url += "/" + idPaymentType;
            method = 'patch';
        }
        

        let create_new_payment_type = await api({
            method: method,
            url: url,
            authorization: this.props.internal.user.access_token,
            params: params
        })
        
        if((create_new_payment_type.success === false && create_new_payment_type.status === 201) || create_new_payment_type.success === true) {
            this.props.internal.setSnackbar(create_new_payment_type.data.message, true)
            this.props.onClose();
        }
        else {
            let resultError = "";
            if(create_new_payment_type.data.data.errors) {
                for(let error in create_new_payment_type.data.data.errors){
                    resultError += create_new_payment_type.data.data.errors[error] + " "
                }
            }
            this.props.internal.setSnackbar( resultError, true)
        }
        }
        else {
            let result = this.props.translate.i18n.GLOBAL.ALERTS.NAME_REQUIRED;
            this.props.internal.setSnackbar( result, true);
        }
    }

    addShop = async(items) => {
        let idPaymentType = toJS(this.props.internal.actionEdit.id)
        this.setState({selectedShops: items, loadingBtn: true})
        let ids = items.map(item => item.value)

        let update_data = await api({
            url: `lists/payment-types/${idPaymentType}`,
            method: 'patch',
            authorization: this.props.internal.user.access_token,
            params: {
                available_for: ids
            }
        })

        if(update_data.success === true) {
            this.props.internal.setSnackbar(update_data.data.message, true)
        }

        this.setState({loadingBtn: false})
    }

    handleClickCollapseGoPay = () => {
        if(toJS(this.props.internal.actionEdit.edit === false)) {
            this.setState(state => ({ is_gopay: !state.is_gopay, is_homecredit: false }));
        }
        
    }

    handleClickCollapseHomecredit = () => {
        if(toJS(this.props.internal.actionEdit.edit === false)) {
            this.setState(state => ({ is_homecredit: !state.is_homecredit, is_gopay: false }));
        }
    }

    render() {
        const { dataForSimpeTable } = toJS(this.props.internal)
        
        return (
            <MuiThemeProvider theme={theme}>
            <Dialog
                open={this.props.open}
                onClose={this.props.onClose}
                aria-labelledby="form-dialog-title"

            >
            
                <DialogTitle id="form-dialog-title">{this.props.title}</DialogTitle>
                <DialogContent className={'dialog-delivery_types'}>
                {this.state.loading
                    ?
                    <CircularProgress className={'circular-progress'} />
                    :
                        <div className={'flex edit-delivery-type flex-column'}>
                        
                            <div className={'flex w-100'}>
                                <CustomInput
                                    ref={ref => this.name = ref}
                                    text={this.props.translate.i18n.MODULES.TRANSPORTS.NAME}
                                    value={this.state.name !== "" ? this.state.name : ""}
                                    id={'title'}
                                    className={"mr-10 w-50"}
                                    required
                                />
                                <CustomInput
                                    ref={ref => this.price = ref}
                                    text={this.props.translate.i18n.MODULES.TRANSPORTS.PRICE}
                                    value={this.state.price !== "" ? this.state.price : ""}
                                    id={'price'}
                                    className={"w-50 text-right"}
                                    // required
                                    endAdornment={{position: "end", value: "€"}}
                                    type={'number'}
                                />
                            </div>
                            <div className={'flex w-100'}>
                                <CustomInput
                                    ref={ref => this.free_from = ref}
                                    text={this.props.translate.i18n.MODULES.TRANSPORTS.FREE_FROM}
                                    value={this.state.free_from !== "" ? this.state.free_from : ""}
                                    id={'free_from'}
                                    className={"mr-10 text-right"}
                                    endAdornment={{position: "end", value: "€"}}
                                    type={'number'}
                                />
                                <CustomInput
                                    ref={ref => this.vat = ref}
                                    text={this.props.translate.i18n.MODULES.TRANSPORTS.VAT}
                                    value={this.state.vat !== "" ? this.state.vat : ""}
                                    id={'vat'}
                                    className={"text-right"}
                                    // required
                                    endAdornment={{position: "end", value: "%"}}
                                    type={'number'}
                                />
                            </div>
                            <CustomInput
                                ref={ref => this.description = ref}
                                text={this.props.translate.i18n.MODULES.TRANSPORTS.DESCRIPTION}
                                value={this.state.description !== "" ? this.state.description : ""}
                                id={'description'}
                                className={"w-100"}
                                multiline
                            />
                            <SelectSearch
                                options={this.state.allShops}
                                onChange={val => this.addShop(val)}
                                value={this.state.selectedShops}
                                isMulti={true}
                                className={'select-search'}
                                label={this.props.translate.i18n.MODULES.TRANSPORTS.AVAILABLE_FOR}
                                // menuIsOpen
                                // onMenuOpen={this.handleScrollDown}
                            />
                            
                            
                            {/* ak sa upravuje druh platby a zaroven je gopay, alebo ak sa vytvara novy druh */}
                            {(toJS(this.props.internal.actionEdit.edit) === true && this.state.is_gopay) || toJS(this.props.internal.actionEdit.edit) === false ||toJS(this.props.internal.actionEdit.edit) === null ?
                                <div>
                                    <ListItem button onClick={this.handleClickCollapseGoPay} disableGutters >
                                    <input
                                        id={"is_gopay"}
                                        type="checkbox"
                                        checked={this.state.is_gopay}
                                        className={'checkboxPayType'}
                                    />
                                    <ListItemText  primary={this.props.translate.i18n.MODULES.PAYMENTS.GO_PAY} className={'primary-text title'}/>
                                    {this.state.is_gopay ? <ExpandLess /> : <ExpandMore />}
                                </ListItem>
                                    <Collapse in={this.state.is_gopay} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding>
                                        <CustomInput
                                            ref={ref => (this.gopay_id = ref)}
                                            text={this.props.translate.i18n.MODULES.PAYMENTS.GO_PAY_ID}
                                            value={this.state.gopay_id}
                                            id={'gopay_id'}
                                            className={'w-100'}
                                            required
                                        />
                                        <CustomInput
                                            ref={ref => (this.gopay_client_id = ref)}
                                            text={this.props.translate.i18n.MODULES.PAYMENTS.GO_PAY_CLIENT_ID }
                                            value={this.state.gopay_client_id}
                                            id={'gopay_client_id'}
                                            className={'w-100'}
                                            required
                                        />
                                        <CustomInput
                                            ref={ref => (this.gopay_client_secret = ref)}
                                            text={this.props.translate.i18n.MODULES.PAYMENTS.GO_PAY_CLIENT_SECRET }
                                            value={ this.state.gopay_client_secret}
                                            id={'gopay_client_secret'}
                                            className={'w-100'}
                                            required
                                        />
                                        
                                    </List>
                                </Collapse>
                                </div>
                                :
                                null
                            }

                            {/* ak sa upravuje druh platby a zaroven je homecredit, alebo ak sa vytvara novy druh */}
                            {(toJS(this.props.internal.actionEdit.edit) === true && this.state.is_homecredit) || toJS(this.props.internal.actionEdit.edit) === false ||toJS(this.props.internal.actionEdit.edit) === null ?
                                <div>
                                    <ListItem button onClick={this.handleClickCollapseHomecredit} disableGutters>
                                        <input
                                            id={"is_homecredit"}
                                            type="checkbox"
                                            checked={this.state.is_homecredit}
                                            className={'checkboxPayType'}
                                        />
                                        {/* <label htmlFor={"is_homecredit"}>{this.props.translate.i18n.MODULES.PAYMENTS.HOMECREDIT}</label> */}
                                        <ListItemText  primary={this.props.translate.i18n.MODULES.PAYMENTS.HOMECREDIT} className={'primary-text title'}/>
                                        {this.state.is_homecredit ? <ExpandLess /> : <ExpandMore />}
                                    </ListItem>
                                    <Collapse in={this.state.is_homecredit} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding>
                                        <CustomInput
                                            ref={ref => (this.homecredit_client_id = ref)}
                                            text={this.props.translate.i18n.MODULES.PAYMENTS.HOMECREDIT_CLIENT_ID}
                                            value={ this.state.homecredit_client_id}
                                            id={'homecredit_client_id'}
                                            className={'w-100'}
                                            required
                                        />
                                        <CustomInput
                                            ref={ref => (this.homecredit_client_secret = ref)}
                                            text={this.props.translate.i18n.MODULES.PAYMENTS.HOMECREDIT_CLIENT_SECRET }
                                            value={this.state.homecredit_client_secret}
                                            id={'homecredit_client_secret'}
                                            className={'w-100'}
                                            required
                                        />
                                        
                                    </List>
                                </Collapse>
                                </div>
                                :
                                null
                            }
                            <ListItem dense onChange={this.handleGPWebPayCheckbox} className={'list-item'}>
                                <input
                                    id={"is_gpwebpay"}
                                    type="checkbox"
                                    value={"is_gpwebpay"}
                                    defaultChecked={this.state.is_gpwebpay ? this.state.is_gpwebpay : false}
                                />
                                <label htmlFor={"is_gpwebpay"}>{this.props.translate.i18n.MODULES.PAYMENTS.IS_GPWEBPAY}</label>
                            </ListItem>
                            <ListItem dense onChange={this.handleChangeCheckbox} className={'list-item'}>
                                <input
                                    id={"production"}
                                    type="checkbox"
                                    value={"production"}
                                    defaultChecked={this.state.production ? this.state.production : false}
                                />
                                <label htmlFor={"production"}>{this.props.translate.i18n.GLOBAL.TABLE.ACTIVE}</label>
                            </ListItem>

                        </div>
                    
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onClose} className={'gray-text'}>
                        {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                    </Button>
                    <Button onClick={this.createNewPaymentType} className={'orange-text'} disabled={this.state.loading}>
                        {this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                    </Button>
                </DialogActions>
                
            </Dialog>
            </MuiThemeProvider>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/payments/AddEdit/index.js